// extracted by mini-css-extract-plugin
export default {"label":"YlKvDWud0SnC2B0_rL8W"};